<template>
  <div class="mb-3">
    <div :class="[task.error ? 'error' : 'no-error']" class="mb-3 p-1 rounded bg-light">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">Task</span>
          </div>
          <select v-model="task.method" @change="changeTask()" class="form-control">
              <option v-for="(item,i) in available_tasks" :value="item" :key="i">{{item}}</option>
          </select>
        </div>
        <component v-bind:is="task.method" :data="task.data" :actions="actions"></component>
    </div>
  </div>
</template>

<style>
.error{
  border-style: dashed;
  border-width: 3px;
  border-color:red;
}
.no-error{
  border-style: solid;
  border-color: #10e22c;
}
</style>

<script>
//chat tasks
import SendAnimation from '@/components/tasks/SendAnimation.vue'
import SendAudio from '@/components/tasks/SendAudio.vue'
import SendContact from '@/components/tasks/SendContact.vue'
import SendDocument from '@/components/tasks/SendDocument.vue'
import SendLocation from '@/components/tasks/SendLocation.vue'
import SendMessage from '@/components/tasks/SendMessage.vue'
import SendPhoto from '@/components/tasks/SendPhoto.vue'
import SendPoll from '@/components/tasks/SendPoll.vue'
import SendQuiz from '@/components/tasks/SendQuiz.vue'
import SendVenue from '@/components/tasks/SendVenue.vue'
import SendVideo from '@/components/tasks/SendVideo.vue'
import SendVideoNote from '@/components/tasks/SendVideoNote.vue'
import SendVoice from '@/components/tasks/SendVoice.vue'

export default {
  name: "BroadcastTask",
  components:{
    SendAnimation,
    SendAudio,
    SendContact,
    SendDocument,
    SendLocation,
    SendMessage,
    SendPhoto,
    SendPoll,
    SendQuiz,
    SendVenue,
    SendVideo,
    SendVideoNote,
    SendVoice,
  },
  props: {
    task: Object
  },
  data: function(){
    return{
      available_tasks: [
        'SendAnimation',
        'SendAudio',
        'SendContact',
        'SendDocument',
        'SendLocation',
        'SendMessage',
        'SendPhoto',
        'SendPoll',
        'SendQuiz',
        'SendVenue',
        'SendVideo',
        'SendVideoNote',
        'SendVoice',
      ],
      task_data:{
        SendAnimation: {to: undefined, animation: null, caption: null, reply_markup: null},
        SendAudio: {to: undefined, audio: null, caption: null, reply_markup: null},
        SendContact: {to: undefined, phone_number: null, first_name: null, last_name: null, reply_markup: null},
        SendDocument: {to: undefined, document: null, caption: null, reply_markup: null},
        SendLocation: {to: undefined, latitude: null, longitude: null, reply_markup: null},
        SendMessage: {to: undefined,text: null, reply_markup: null},
        SendPhoto: {to: undefined, photo: null, caption: null, reply_markup: null},
        SendPoll: {to: undefined, question: null, options:[null,null], is_anonymous:true, allows_multiple_answers:undefined, reply_markup: null},
        SendQuiz: {to: undefined, question: null, options:[null,null], is_anonymous:true, correct_option_id:0, type:'quiz', reply_markup: null},
        SendVenue: {to: undefined, latitude: null, longitude: null, title: null, address: null, reply_markup: null},
        SendVideo: {to: undefined, video: null, caption: null, reply_markup: null},
        SendVideoNote: {to: undefined, video_note: null, caption: null, reply_markup: null},
        SendVoice: {to: undefined, voice: null, caption: null, reply_markup: null},
      },
      actions: {
        commands: [],
        callbacks: [],
        reply_buttons: [],
        keywords: [],
        schedules: []
      },
    }
  },
  methods:{
    changeTask: function(){
      let data = this.task_data[this.task.method];
      let newData = JSON.parse(JSON.stringify(data));
      this.task.data = newData;
    },
  },
}
</script>
